module.exports = __webpack_public_path__ + "static/media/dashboard.b8339b4c.png";